
<template>
    <control-wrapper v-bind="controlWrapper" :styles="styles" :isFocused="isFocused" :appliedOptions="appliedOptions">

        <v-combobox @input="onChange" :placeholder="appliedOptions.placeholder" :label="computedLabel"
            :required="control.required" :error-messages="control.errors" hide-no-data :id="control.id + '-input'"
            v-model="control.data" v-bind="vuetifyProps('v-combobox')" :loading="loading" @focus="querySelections"
            @blur="isFocused = false" clearable noDataText="暂无数据" :items="items" :search-input.sync="search" :disabled="readonly ||appliedOptions.disabled "
            cache-items></v-combobox>


    </control-wrapper>
</template>

<script>
import { formatIs, rankWith, } from '@jsonforms/core';

import { rendererProps, useJsonFormsControl } from '@jsonforms/vue2';
import { useVuetifyControl, ControlWrapper } from '@jsonforms/vue2-vuetify';
import { defineComponent, ref } from 'vue';
import apiAxios from "@/config/apiAxios";
const controlRenderer = defineComponent({
    name: 'companyfullName',
    components: {
        ControlWrapper
    },
    props: {
        ...rendererProps(),
    },
    inject: ['jsonforms'],
    setup(props) {
        const loading = ref(false);
        const items = ref([]);
        const search = ref('');
        const timeout = ref(null);
        // const rootData=ref({})
        // const { proxy } = getCurrentInstance()
        // const rootData=toRef(reactive(proxy.jsonforms.core.data))
        // const ctx=JsonForms.core.data;// 获取JsonForms 上下文
        const control = useVuetifyControl(useJsonFormsControl(props), (value) => value || undefined);
        return { ...control, loading, items, search, timeout }
    },
    mounted() {
        // const ctx=this.jsonforms; // 获取上下文
        // this.rootData=ctx.core.data;
        // this.GE8002009E=this.rootData.GE8002009E
    },
    computed: {
        readonly(){
            return this.jsonforms.readonly 

        }
          
          
    },
    methods: {


        querySelections(val) {

            //  console.log(this.rootData);
            this.loading = true;
            let _url = `${config.serverUrl}/cmfs/v1/thdb/lexicon/organization?filter=matchesPattern('full_text','.*${val}.*')&limit=10`

            let that = this;
            if (this.timeout) {
                clearTimeout(this.timeout)
            } else {
                setTimeout(() => {
                    apiAxios.get(_url, {}, res => {
                        that.loading = false;
                        if (res.code == 200) {
                            let items = []
                            res.data.map(function (d) {
                                // let obj={}
                                // obj.text=`${d.seccode} ${d.fullName}`
                                // obj.value=d.fullName
                                // items.push(obj)
                                items.push(d.fullName)
                            })

                            that.items = items
                        }

                    })

                }, 1000)
            }

        }
    },
    // computed:{
    //     rootData1(){
    //         return this.jsonforms.core.data
    //     }
    // },
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },
        //   'rootData1.GE8002009E':{
        //     handler(newVal){
        //         console.log()
        //     },
        //     deep:true
        //   },

    },
})

export default controlRenderer;
export const entry = {
    renderer: controlRenderer,
    tester: rankWith(10, formatIs("zysl-companyfullName")),
};
</script>
<style lang="less" scoped>

</style>
